module.exports = __webpack_public_path__ + "static/media/expired.94abd02d.png";